<template>
  <div class="report">
    <div class="report_title">{{ $t('home.report.title') }}</div>
    <div class="report_cont">
      <div class="report_li" v-for="(el, index) in reportData" @click="linkhref(el.link)">
        <img class="li_img" :src="el.img" alt="">
        <div class="li_content">
          <div class="title">{{ el.name }}</div>
          <div class="text1">{{ el.subjection }}</div>
          <div class="text2"><p>{{ el.data }}</p></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, onMounted ,computed } from "vue";
  import { useI18n } from "vue-i18n";
  import { useStore } from "vuex"
  import media_img5 from "@/assets/media/media_img5.avif"
  import media_img4 from "@/assets/media/media_img4.png"
  import media_img from "@/assets/media/media_img.png"
  import media_img2 from "@/assets/media/media_img2.webp"
  import media_img1 from "@/assets/media/media_img1.webp"
  export default defineComponent({
    name: 'report',
    setup() {
      const { t, locale } = useI18n()
      const store = useStore()
      let lan = computed(() => store.state.lan)
      const reportData = ref([
        {
          name: 'AIとゲームの革命：DeepBrain Chainによるブロックチェーンの革新と DeepLink Protocolを通じた日本のゲーム産業の新たな夜明け',
          link: 'https://jp.cointelegraph.com/press-releases/ai-and-the-game-revolution-a-new-dawn-for-the-japanese-game-industry',
          data: '2024年04月05日 / 16:25',
          subjection: 'cointelegraph',
          img: media_img5
        },
        {
          name: '딥링크 프로토콜, ‘2024년 제품 개발 로드맵’ 공개',
          link: 'https://naver.me/xRPw8etS',
          data: '2024-04-09 18:21 (화)',
          subjection: 'datanet',
          img: media_img4
        },
        {
          name: '去中心化AI云游戏协议DeepLink Protocol完成超800万美元融资，ROCK Ventures等参投',
          link: 'https://www.theblockbeats.info/flash/242999',
          data: '2024-04-02 15:00',
          subjection: 'blockbeats',
          img: media_img
        },
        {
          name: 'DeepLink Research Report',
          link: 'https://medium.com/@DeepLinkGlobal/deeplink-research-report-b64c6776c84d',
          data: '2024-04-09 08:40',
          subjection: 'medium',
          img: media_img2
        },
        {
          name: 'DeepLink Protocol Innovative Home Mining Solution',
          link: 'https://medium.com/@DeepLinkGlobal/deeplink-protocol-innovative-home-mining-solution-3d2e9c6d0dca',
          data: 'Feb 7, 2024',
          subjection: 'medium',
          img: media_img1
        }
      ])
      const linkhref = (val) => {
        window.open(val)
      }
      return {
        lan,
        linkhref,
        reportData
      };
    }
  })
</script>

<style scoped lang="scss">
.report {
  width: 1200px;
  margin: 0 auto 60px;
  box-sizing: border-box;
  .show {
    display: block;
  }
  .hide {
    display: none;
  }
  .report_title {
    color: #fff;
    font-size: 26px;
    font-weight: 600;
    line-height: 34px;
    text-align: center;
    margin-bottom: 30px;
    letter-spacing: 0.05em;
  }
  .report_cont {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .report_li {
      width: 388px;
      display: flex;
      cursor: pointer;
      overflow: hidden;
      margin-right: 18px;
      border-radius: 24px;
      align-items: center;
      margin-bottom: 12px;
      background: rgba(152, 255, 194, 0.12);
      &:nth-child(3n) {
        margin-right: 0;
      }
      .li_img {
        width: 120px;
        height: 140px;
        object-fit: cover;
      }
      .li_content {
        flex: 1;
        height: 140px;
        display: flex;
        padding: 10px;
        box-sizing: border-box;
        flex-direction: column;
        justify-content: space-between;
        .title {
          width: 100%;
          height: 66px;
          color: #fff;
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          letter-spacing: 0em;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
        .text1 {
          color: rgba(255, 255, 255, 0.6);
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: 0em;
        }
        .text2 {
          display: flex;
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: 0em;
          align-items: center;
          justify-content: space-between;
          color: rgba(255, 255, 255, 0.6);
          .text2_2 {
            display: flex;
            align-items: center;
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            letter-spacing: 0em;
            .icon {
              width: 14px;
              height: 14px;
              margin-right: 4px;
              display: inline-block;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .report {
    width: 90%;
    .show {
      display: none;
    }
    .hide {
      display: block;
    }
    .report_cont {
      .report_li {
        width: 100%;
        margin-right: 0;
        .li_img {
          width: 150px;
        }
      }
      
    }
  }
}
</style>